{
  "format": "aomr-bob",
  "version": 7,
  "id": "preset:krush",
  "name": "Krush",
  "author": "IKazart",
  "createdAt": "2026-10-17T13:00:00Z",
  "updatedAt": "2026-11-03T04:47:52.068Z",
  "pantheon": "atlanteans",
  "god": "kronos",
  "type": "rush",
  "objective": {
    "pt-BR": "Clássica rápida com Prometeu, Contraquartel na frente com Time Shift e pressão de Turmas; Heroica com Rheia.",
    "en": "Fast Classical with Prometheus, forward Temple via Time Shift and pressure. Heroic with Rheia to close the game with Behemoths."
  },
  "end": {
    "pt-BR": "Heroica com Rheia (2 Behemoths grátis) e pressão de Turmas na base inimiga.",
    "en": "Final Behemoths raid to destroy the base."
  },
  "settings": {
    "tick": 1,
    "foodChain": ["hunt", "hunt", "hunt", "herd", "berries", "farm"]
  },
  "milestones": [],
  "matchups": [
    {
      "god": "loki",
      "fit": "neutral"
    },
    {
      "god": "hades",
      "fit": "bad"
    },
    {
      "god": "poseidon",
      "fit": "bad"
    },
    {
      "god": "kronos",
      "fit": "neutral"
    },
    {
      "god": "zeus",
      "fit": "bad"
    },
    {
      "god": "gaia",
      "fit": "good"
    },
    {
      "god": "oranos",
      "fit": "good"
    },
    {
      "god": "ra",
      "fit": "good"
    },
    {
      "god": "set",
      "fit": "good"
    },
    {
      "god": "isis",
      "fit": "bad"
    },
    {
      "god": "odin",
      "fit": "neutral"
    },
    {
      "god": "thor",
      "fit": "neutral"
    }
  ],
  "actions": [
    {
      "id": "g0",
      "when": "0:00",
      "do": "move",
      "count": 2,
      "from": "idle",
      "to": "gold"
    },
    {
      "id": "c1",
      "when": "0:00",
      "do": "train",
      "unit": "citizen",
      "count": 3,
      "rally": "food"
    },
    {
      "id": "t1",
      "when": "0:35",
      "do": "build",
      "building": "temple",
      "builder": {
        "new": "c1"
      },
      "then": "food"
    },
    {
      "id": "f1",
      "when": "0:35",
      "do": "move",
      "count": 2,
      "from": "gold",
      "to": "food"
    },
    {
      "id": "cl",
      "when": "1:55",
      "do": "age",
      "to": "classical",
      "minor": "prometheus"
    },
    {
      "id": "w1",
      "when": "1:55",
      "do": "move",
      "count": 2,
      "from": "hunt",
      "to": "wood"
    },
    {
      "id": "g1",
      "when": "1:55",
      "do": "move",
      "count": 1,
      "from": "hunt",
      "to": "gold"
    },
    {
      "id": "ts1",
      "when": "2:00",
      "do": "timeShift",
      "building": "temple"
    },
    {
      "id": "m1",
      "when": "2:15",
      "do": "build",
      "building": "manor",
      "builder": {
        "from": "wood"
      },
      "then": "wood"
    },
    {
      "id": "dc",
      "when": "2:50",
      "do": "power",
      "power": "deconstruction",
      "target": "temple"
    },
    {
      "id": "c2",
      "when": {
        "after": "cl"
      },
      "do": "train",
      "unit": "citizen",
      "count": 1,
      "rally": "wood"
    },
    {
      "id": "o1",
      "when": {
        "after": "cl"
      },
      "do": "promote",
      "unit": "oracle"
    },
    {
      "id": "pr",
      "when": {
        "after": "cl"
      },
      "do": "train",
      "unit": "promethean",
      "count": 1,
      "at": "temple"
    },
    {
      "id": "a39",
      "when": {
        "after": "cl"
      },
      "note": "Start raiding",
      "do": "event"
    },
    {
      "id": "a27",
      "when": {
        "after": "a39",
        "on": "start",
        "asap": true
      },
      "do": "train",
      "unit": "promethean",
      "count": 1,
      "at": "temple"
    },
    {
      "id": "a26",
      "when": {
        "after": "a27",
        "on": "start",
        "asap": true
      },
      "do": "build",
      "building": "military-barracks",
      "builder": {
        "from": "wood"
      },
      "then": "wood"
    },
    {
      "id": "auto",
      "when": "3:25",
      "do": "train",
      "unit": "citizen",
      "mode": "auto",
      "duration": 191,
      "rally": "food"
    },
    {
      "id": "a24",
      "when": {
        "after": "auto",
        "on": "start",
        "asap": true
      },
      "do": "timeShift",
      "building": "military-barracks"
    },
    {
      "id": "a25",
      "when": {
        "after": "a24",
        "on": "start",
        "asap": true
      },
      "do": "train",
      "unit": "murmillo",
      "count": 1
    },
    {
      "id": "o2",
      "when": {
        "after": "a25",
        "on": "start",
        "asap": true
      },
      "do": "promote",
      "unit": "oracle"
    },
    {
      "id": "a30",
      "when": {
        "after": "o2",
        "on": "start",
        "asap": true
      },
      "do": "train",
      "unit": "promethean",
      "count": 1,
      "at": "temple"
    },
    {
      "id": "m2",
      "when": "5:00",
      "do": "build",
      "building": "manor",
      "builder": {
        "from": "wood"
      },
      "then": "wood"
    },
    {
      "id": "a28",
      "when": {
        "after": "m2",
        "on": "start",
        "asap": true
      },
      "do": "train",
      "unit": "murmillo",
      "count": 1
    },
    {
      "id": "a29",
      "when": {
        "after": "a28",
        "on": "start",
        "asap": true
      },
      "do": "train",
      "unit": "murmillo",
      "count": 1
    },
    {
      "id": "ar",
      "when": "5:25",
      "do": "build",
      "building": "armory",
      "builder": {
        "from": "wood"
      },
      "then": "gold"
    },
    {
      "id": "g2",
      "when": {
        "after": "ar",
        "on": "start"
      },
      "do": "move",
      "count": 1,
      "from": "wood",
      "to": "gold"
    },
    {
      "id": "m3",
      "when": "5:55",
      "do": "build",
      "building": "manor",
      "builder": {
        "from": "wood"
      },
      "then": "wood"
    },
    {
      "id": "h1",
      "when": {
        "after": "m3",
        "on": "start",
        "asap": true
      },
      "do": "age",
      "to": "heroic",
      "minor": "rheia"
    },
    {
      "id": "a35",
      "when": {
        "after": "h1",
        "on": "start"
      },
      "do": "train",
      "unit": "citizen",
      "mode": "auto",
      "rally": "gold"
    },
    {
      "id": "a36",
      "when": {
        "after": "h1",
        "on": "start"
      },
      "do": "move",
      "count": 1,
      "from": "gold",
      "to": "wood"
    },
    {
      "id": "a34",
      "when": {
        "after": "a36",
        "on": "start",
        "asap": true
      },
      "do": "build",
      "building": "economic-guild",
      "builder": {
        "from": "wood"
      },
      "then": "wood"
    },
    {
      "id": "a37",
      "when": {
        "after": "a34",
        "on": "start",
        "asap": true
      },
      "do": "research",
      "research": "theft-of-fire"
    },
    {
      "id": "a32",
      "when": {
        "after": "a37",
        "on": "start",
        "asap": true
      },
      "do": "train",
      "unit": "promethean",
      "count": 2
    },
    {
      "id": "a33",
      "when": {
        "after": "a32",
        "on": "start",
        "asap": true
      },
      "do": "train",
      "unit": "murmillo",
      "count": 2
    },
    {
      "id": "a38",
      "when": {
        "after": "h1"
      },
      "note": "On a citizen gathering gold",
      "do": "power",
      "power": "valor"
    },
    {
      "id": "a31",
      "when": {
        "after": "h1"
      },
      "note": "Finishing Raid with Behemoths",
      "do": "event"
    }
  ]
}
